export const keywordFormSchema = {
  type: "object",
  properties: {
    name: {
      type: "string",
      title: "Name",
      description: "The name of the keyword group",
    },
    slug: {
      type: "string",
      title: "Slug",
      description: "URL-friendly identifier for the keyword group",
    },
    imageUrl: {
      type: "string",
      title: "Image URL",
      description: "URL of the image for the keyword group",
    },
    type: {
      type: "string",
      title: "Type",
      description: "The type or category of the keyword group",
      enum: ["BRAND", "SUB_BRAND", "PRODUCT", "OUTLET"],
    },
    keywords: {
      type: "array",
      title: "Keywords",
      description: "List of keywords in this group",
      items: {
        type: "string",
      },
      minItems: 1,
    },
  },
  required: ["name", "slug", "type", "keywords"],
};

export const keywordUISchema = {
  type: "VerticalLayout",
  elements: [
    {
      type: "Control",
      scope: "#/properties/name",
      options: {
        placeholder: "Enter keyword group name",
      },
    },
    {
      type: "Control",
      scope: "#/properties/imageUrl",
      options: {
        placeholder: "https://example.com/image.jpg",
        showUnfocusedDescription: true,
        description: "Enter a valid image URL (jpg, jpeg, png, gif, bmp, webp, svg)",
      },
    },
    {
      type: "Control",
      scope: "#/properties/slug",
      options: {
        placeholder: "Enter URL-friendly slug",
      },
    },
    {
      type: "Control",
      scope: "#/properties/type",
      component: "stringSelect",
      placeholder: "Select",
      options: {
        labelMapping: {
          BRAND: "BRAND",
          SUB_BRAND: "SUB_BRAND",
          PRODUCT: "PRODUCT",
          OUTLET: "OUTLET",
        },
      },
    },
    {
      type: "Control",
      scope: "#/properties/keywords",
      component: "KeywordChipsRenderer",
      options: {
        customRenderer: "KeywordChipsRenderer",
      },
    },
  ],
};
